module.exports = __webpack_public_path__ + "static/media/review-two_60x60.29531747.jpg";